import { type CSSProperties } from 'react'
import { css, type SerializedStyles } from '@emotion/react'
import { rem } from 'polished'

import { RADIUS_0 } from '@Styles/constants/radius'

export const scrollbarTheming = (
  scrollbarColor: CSSProperties['color'],
  scrollbarThumbColor: CSSProperties['color'],
): SerializedStyles =>
  css({
    '&::-webkit-scrollbar': {
      backgroundColor: scrollbarColor,
      width: rem(8),
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: scrollbarThumbColor,
      borderRadius: RADIUS_0,
    },
    scrollbarColor: `${scrollbarThumbColor} ${scrollbarColor}`,
    scrollbarWidth: 'thin',
  })
